<div class="cpp-content-marketing">
    <div class="cpp-heading">
      <div class="cpp-heading__content">
        <!-- <img src="../../../../assets/images/marketplace.svg" width="1252px" alt="{{ labels['marketplace.title'] }}" role="presentation"/> -->
        <span class="cpp-heading__title">{{ labels['billingplatform.title'] }}</span>
      </div>
    </div>
  
    <div>
      <p>{{descriptionOne}} <br/>
      </p>
      <p>{{descriptionTwo}} <br/><br/>
      </p>
    </div>
    <div class="spotlight">
      <a
        target="billingplatform"
        [href]="redirectBillingplatformUrl">      
        <button class="cpp-button-access-platform"><b>{{ labels['billingplatform.button'] }}</b></button>
      </a>
    </div>
    <div class="banner-image">
    </div>
  </div>
  
  
  